<template>
    <v-autocomplete
            v-model="geoModel"
            :items="geoList"
            :loading="isLoadingGeo"
            :search-input.sync="geoSearch"
            hide-no-data
            item-text="name"
            item-value="id"
            :label="geoLabel"
            @change="geoChange"
            return-object
            clearable
            cache-items
            item-color="orange lighten-2"
            color="orange lighten-2"
    ></v-autocomplete>
</template>

<script>
    import geoService from "../../../app-front/services/api/GeoService";

    export default {
        name: "GeoSearch",
        props:['geo', 'label', 'parentId'],
        data(){
            return {
                geoEntries:[],
                geoModel: {},
                geoSearch: null,
                isLoadingGeo: false,
            }
        },
        computed: {
            geoLabel(){
                if(this.label) {
                    return this.label;
                }

                return this.$t('city');
            },
            geoList() {
                return this.geoEntries.map(entry => {
                    const name = entry.name;
                    return Object.assign({}, entry, { name })
                }).filter(entry => !!entry.name)
            },
            regions() {
                return this.$store.state.geo.regions;
            },
        },
        methods: {
            geoChange(){
                this.$emit('geo-change', this.geoModel);
            },
            setGeoModel(geo) {
                if(!geo) return false;

                this.geoModel = geo;

                if (!this.geoEntries.length) {
                    this.geoEntries = [this.geoModel];
                }
            },
            async getListGeneral(){
                return await geoService.getGeoList();
            }
        },
        created(){
            this.setGeoModel(this.geo);
        },
        watch: {
            geo(){
                this.setGeoModel(this.geo);
            },
            geoSearch(val) {
                if(val && val.length < 3) return;

                if(this.geoModel && val === this.geoModel.name) return;

                if (this.isLoadingGeo) return;

                this.isLoadingGeo = true;

                geoService.getGeoSearch(val, this.parentId)
                    .then(res => {
                        this.geoEntries = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .then(() => (
                        this.isLoadingGeo = false
                    ));
            },
        }

    }
</script>

<style scoped>

</style>
